import { render, staticRenderFns } from "./add-letter.vue?vue&type=template&id=21c50b15&scoped=true&"
import script from "./add-letter.vue?vue&type=script&lang=js&"
export * from "./add-letter.vue?vue&type=script&lang=js&"
import style0 from "./add-letter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./add-letter.vue?vue&type=style&index=1&id=21c50b15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c50b15",
  null
  
)

export default component.exports